export enum InstallFlowDeviceOrder {

    dismantledImages,
    confirmAnalyzedData,
    serial,
    addedMoreSerial,
}